export { getJudgeFactoryPath, JUDGE_FACTORY_ROUTE_PATTERN } from './routes';

export function loadJudgeFactoryPage() {
  return import('./pages/JudgeFactoryPage/JudgeFactoryPage');
}
